/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Shared fields and validation for planner request serializers.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerCalendarViewRequest { 
    appointmentTypeIds: Array<number>;
    therapistIds: Array<number>;
    date: string;
}
export const PlannerCalendarViewRequest_appointmentTypeIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewRequest_therapistIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewRequest_date_Validators: ValidatorFn[] =
    [  Validators.required, ];


